import VSwitch from './VSwitch'

VSwitch.install = function install (Vue) {
  Vue.component(VSwitch.name, VSwitch)
}

export default VSwitch



// WEBPACK FOOTER //
// ./src/components/VSwitch/index.js